import styled, { css, keyframes } from "styled-components";
import rocketSrc from "assets/images/rocket.png";
import rocketHoverSrc from "assets/images/hover/rocket-hover.png";
import checkroadmapSrc from "assets/images/bubbleText/checkroadmap.png";

const fly = keyframes`
  0%{
    transform: translateY(0);
  }
  100%{
    transform: translateY(-400px);
  }

`;

const shaking = keyframes`
0%{
  margin-left: -4px;
}100%{
  margin-left: 4px;
}
`;

export const ImgWrapper = styled.div<{ clicked: boolean }>`
  position: absolute;
  display: block;
  width: 6.5%;
  height: 24%;
  left: 30.2rem;
  top: 8.4rem;
  background-image: url(${rocketSrc});
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;

  :hover {
    background-image: url(${rocketHoverSrc});
    ::after {
      position: absolute;
      background-image: url(${checkroadmapSrc});
      background-size: contain;
      display: inline-block;
      width: 250%;
      height: 55%;
      content: "";
      background-repeat: no-repeat;
      top: 0;
      right: 0;
      transform: translate(95%, 5%);
    }
  }

  ${({ clicked }) =>
    clicked &&
    css`
      background-image: url(${rocketHoverSrc});
      animation: 0.1s linear ${shaking} 5, 0.5s linear ${fly} 0.7s forwards;
    `}
  ${({ theme }) => theme.mediaWidth.upToMedium`
      left: 63.5vw;
      top: 17.8vw;
  `}
`;
